import React, { useState } from 'react';
import { ConfiguratorComponent } from '../Forms/types';
import { Grid, Typography } from '@material-ui/core';
import { ToggleButton, ToggleButtonGroup } from '@material-ui/lab';
import { t } from '@configuratorware/configurator-frontendgui/Framework/i18n';
import { useStyles } from './styles';
import { useDispatch } from 'react-redux';
import { setCustomData } from '../../Reducers/Configurator/Actions';
import { selectOption } from '@configuratorware/configurator-frontendgui/App/Reducers/Configurator/Actions';

interface NozzleOptionProps {
  component: ConfiguratorComponent;
  zoneNumber: number;
  defaultValue: string;
}

const NozzleOption: React.FC<NozzleOptionProps> = (props) => {
  const { component, zoneNumber, defaultValue } = props;
  const [value, setValue] = useState(defaultValue);
  const classes = useStyles();
  const dispatch = useDispatch();

  const handleClick = (option) => {
    setValue(option.identifier);
    dispatch(setCustomData({ [component.identifier]: option.identifier }));
    dispatch(selectOption({ ...option, amount: option.amount ? 0 : 1 }, false, false, component));
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={4} container direction="column" justifyContent={'center'}>
        <Typography>
          {t('coolingZone.zone')} {zoneNumber}
        </Typography>
      </Grid>
      <Grid item xs={8} container direction="column" alignItems="flex-end">
        <ToggleButtonGroup className={classes.buttonGroup} value={value}>
          {component.options.map((option) => (
            <ToggleButton
              key={option.identifier}
              value={option.identifier}
              onClick={() => handleClick(option)}
            >
              {t(option.title)}
            </ToggleButton>
          ))}
        </ToggleButtonGroup>
      </Grid>
    </Grid>
  );
};

export default NozzleOption;
